/* eslint-disable react/display-name */
import React from 'react';
import classNames from 'classnames';

const Button = React.forwardRef((props, ref) => {
  const style = props.style || 'solid';
  const variant = props.variant || 'dark';
  const theme = 'defaultTheme';
  const disabled = props.disabled;
  const onClick = props.onClick;
  const href = props.href;
  const type = props.type;

  return (
    <button
      onClick={onClick}
      href={href}
      ref={ref}
      disabled={disabled}
      type={type == 'submit' ? 'submit' : 'button'}
      className={classNames({
        /* Default Styling for All Button Styles */
        'text-sm duration-default hover:cursor-pointer':
          theme == 'defaultTheme',

        /* Solid Button Base Style */
        'flex items-center rounded-button py-2 px-4 hover:opacity-80':
          style == 'solid',

        /* Underline Button Base Style */
        'bg-transparent text-center underline underline-offset-4 hover:opacity-80':
          style == 'underline',

        /* Border Button Base Style */
        'w-full rounded-button border-width-mini bg-transparent px-4 py-4 text-lg':
          style == 'border',

        /* Admin Button Base Style */
        'rounded-button px-2 py-4 text-lg hover:opacity-80': style == 'admin',

        /* Color Configurations */
        'bg-primary text-primaryText': style == 'solid' && variant == 'primary',
        'bg-secondary text-secondaryText':
          style == 'solid' && variant == 'secondary',
        'bg-tertiary text-light': style == 'solid' && variant == 'tertiary',
        'bg-error text-light': style == 'solid' && variant == 'error',
        'bg-warning text-light': style == 'solid' && variant == 'warning',
        'bg-success text-light': style == 'solid' && variant == 'success',
        'bg-light text-dark': style == 'solid' && variant == 'light',
        'bg-grey text-light': style == 'solid' && variant == 'grey',
        'bg-dark text-light': style == 'solid' && variant == 'dark',
        'text-primary': style == 'underline' && variant == 'primary',
        'text-secondary': style == 'underline' && variant == 'secondary',
        'text-tertiary': style == 'underline' && variant == 'tertiary',
        'text-error': style == 'underline' && variant == 'error',
        'text-warning': style == 'underline' && variant == 'warning',
        'text-success': style == 'underline' && variant == 'success',
        'text-light': style == 'underline' && variant == 'light',
        'text-grey': style == 'underline' && variant == 'grey',
        'text-dark': style == 'underline' && variant == 'dark',
        'border-primary text-primary hover:bg-primary hover:text-primaryText':
          style == 'border' && variant == 'primary',
        'border-secondary text-secondary hover:bg-secondary hover:text-secondaryText':
          style == 'border' && variant == 'secondary',
        'border-tertiary text-tertiary hover:bg-tertiary hover:text-light':
          style == 'border' && variant == 'tertiary',
        'border-error text-error hover:bg-error hover:text-light':
          style == 'border' && variant == 'error',
        'border-warning text-warning hover:bg-warning hover:text-light':
          style == 'border' && variant == 'warning',
        'border-success text-success hover:bg-success hover:text-light':
          style == 'border' && variant == 'success',
        'border-light text-light hover:bg-light hover:text-dark':
          style == 'border' && variant == 'light',
        'border-grey text-grey hover:bg-grey hover:text-light':
          style == 'border' && variant == 'grey',
        'border-dark text-dark hover:bg-dark hover:text-light':
          style == 'border' && variant == 'dark',
        'w-full bg-primary text-primaryText':
          style == 'admin' && variant == 'primary',
        'w-full bg-secondary text-secondaryText':
          style == 'admin' && variant == 'secondary',
        'w-full bg-tertiary text-light':
          style == 'admin' && variant == 'tertiary',
        'w-full bg-error text-light': style == 'admin' && variant == 'error',
        'w-full bg-warning text-light':
          style == 'admin' && variant == 'warning',
        'w-full bg-success text-light':
          style == 'admin' && variant == 'success',
        'w-full bg-grey-200 text-dark': style == 'admin' && variant == 'light',
        'w-full bg-grey-800 text-light': style == 'admin' && variant == 'dark',
      })}
    >
      {props.children}
    </button>
  );
});

export default Button;
